<template>
  <div :class="{rtl: isRtl}">
    <RamadanModal :show="modalIsOpen" @update:show="modalIsOpen = $event" />

    <transition name="slide-fade">
      <div v-if="expandedHeader" class="ramadan-header" @click="showModal">
        <div class="ramadan-header__content">
          <div class="ramadan-header__background">
            <img
              src="./assets/background-pattern.png"
              alt="background"
              class="ramadan-header__background-image"
            />
            <img
              src="./assets/background-pattern.png"
              alt="background"
              class="ramadan-header__background-image ramadan-header__background-image_reversed"
            />
          </div>
          <img class="ramadan-header__logo" src="./assets/app-logo.svg" alt="qic app logo" />
          <div class="ramadan-header__title">
            <span class="ramadan-header__text-1">{{ $t('ramadan.motor.header.text.1') }}</span>
            <div class="ramadan-header__images">
              <img src="./assets/car.png" alt="car" class="ramadan-header__car" />
              <img src="./assets/light.png" alt="light" class="ramadan-header__light" />
            </div>
            <span class="ramadan-header__text-2">{{ $t('ramadan.motor.header.text.2') }}</span>
          </div>
          <button class="ramadan-header__button" @click.stop="close" aria-label="close button">
            <img src="./assets/x-close.svg" alt="close" />
          </button>
        </div>
      </div>
    </transition>
    <transition name="slide">
      <div v-if="!expandedHeader" class="ramadan-gifts" @click="showModal">
        <img src="./assets/gifts.png" alt="gifts" class="ramadan-gifts__image" />
      </div>
    </transition>
  </div>
</template>

<script>
import RamadanModal from './RamadanModal.vue'
import { mapMutations, mapState } from 'vuex'
import { trackGtag } from '@/utils/useGtag'

export default {
  data () {
    return {
      expandedHeader: true,
      modalIsOpen: false
    }
  },
  components: {
    RamadanModal
  },
  computed: {
    ...mapState({
      ramadanExpanded: state => state.ramadan.ramadanExpanded
    }),
    locale () {
      return this.$i18n.locale
    },
    isRtl () {
      return this.locale === 'ar'
    }
  },
  methods: {
    ...mapMutations([
      'setRamadanExpanded'
    ]),
    showModal () {
      this.modalIsOpen = true
      const page = window.location.pathname.split('/').filter(Boolean).pop() || ''
      trackGtag('view_popup', {
        product: 'renewal',
        category: 'carIns',
        page,
        promo_name: 'ramadan'
      })
    },

    close () {
      this.expandedHeader = false
      this.setRamadanExpanded(false)
      const page = window.location.pathname.split('/').filter(Boolean).pop() || ''
      trackGtag('click_link', {
        product: 'renewal',
        category: 'carIns',
        promo_name: 'ramadan',
        page,
        link_title: 'ramadan_header'
      })
    }
  },
  mounted () {
    this.expandedHeader = this.ramadanExpanded
  }
}
</script>

<style lang="scss" scoped>
.ramadan-gifts {
  position: absolute;
  height: min-content;
  width: min-content;
  top: 7%;
  right: 1%;
  z-index: 4;
  cursor: pointer;
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
}

.ramadan-gifts__image {
  cursor: pointer;
  width: 72px;
  height: 72px;
  transition:
    width 0.3s ease,
    height 0.3s ease;
}

.ramadan-gifts:hover .ramadan-gifts__image {
  width: 80px;
  height: 80px;
}

/* анимация переходов */
.slide-enter-active {
  opacity: 1;
  transform: translateX(0);
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.ramadan-header {
  background: linear-gradient(-2deg, #6568f4 -16.03%, #df7be8 104.26%, #ffb0b5 211.63%);
  width: 100%;
  max-height: 60px;
  cursor: pointer;
}

.ramadan-header__content {
  display: grid;
  align-items: center;
  grid-template-rows: 60px;
  grid-template-columns: 1fr auto 1fr;
  max-height: inherit;
  overflow: hidden;
  position: relative;
  padding-inline: 31px 33px;
  max-width: 1440px;
  margin-inline: auto;
  cursor: pointer;
}

.slide-fade-leave-active {
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out,
    max-height 0.5s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-60px);
  max-height: 0;
}

.ramadan-header__background {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ramadan-header__background-image {
  max-width: 426px;
  width: 100%;
}

.ramadan-header__background-image_reversed {
  scale: -1;
}

.ramadan-header__logo {
  justify-self: start;
  z-index: 2;
}

.ramadan-header__images {
  position: relative;
  min-width: 142px;
  height: 60px;
  grid-area: image;
}

.ramadan-header__text-1 {
  grid-area: text-first;
}

.ramadan-header__text-2 {
  grid-area: text-second;
}

.ramadan-header__car {
  width: 142px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
}

.ramadan-header__light {
  position: absolute;
  left: 46%;
  top: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.ramadan-header__title {
  display: flex;
  align-items: center;
  z-index: 2;
  gap: 14px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  font-family: 'PP Neue Montreal', sans-serif;
}

.ramadan-header__button {
  border: none;
  display: flex;
  width: 44px;
  height: 44px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(calc(20px / 2));
  z-index: 3;
  justify-self: end;
  cursor: pointer;
}

@media (max-width: 850px) {
  .ramadan-header__content {
    grid-template-columns: 90% 1fr;
    padding-inline: 14px 11px;
  }

  .ramadan-header__logo {
    display: none;
  }

  .ramadan-header__title {
    font-size: 30px;
    justify-content: center;
    gap: 0;
  }
}

@media (max-width: 550px) {
  .ramadan-header {
    grid-template-columns: 86% 1fr;
  }

  .ramadan-header__content {
    padding-inline: 14px 18px;
  }

  .ramadan-header__title {
    font-size: 22px;
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-template-areas:
      'text-first image'
      'text-second image';
    gap: initial;
    margin-inline-start: initial;
    text-align: start;
    line-height: 23px;
    justify-content: start;
    font-weight: 500;
  }

  .ramadan-header__text-1 {
    align-self: end;
  }
  .ramadan-header__text-2 {
    align-self: start;
  }

  .ramadan-header__background-image {
    width: 313px;
  }

  .ramadan-header__button {
    width: 33px;
    height: 33px;
    :deep(img) {
      width: 18px;
    }
  }

  .ramadan-header__light {
    left: 70%;
  }

  .ramadan-header__car {
    left: 60%;
  }
}

.rtl {
  .ramadan-header {
    direction: rtl;
  }

  .ramadan-gifts {
    right: initial;
    left: 1%;
  }

  .ramadan-header__car {
    transform: translate(-50%, -50%) scaleX(-1);
  }

  @media (max-width: 550px) {
    .ramadan-header__light {
      left: 30%;
    }

    .ramadan-header__car {
      left: 40%;
    }
  }
}
</style>
